import { DollarSign, Shield, Users, Zap, HeadphonesIcon, TrendingUp } from "lucide-react";

const benefits = [
  {
    icon: DollarSign,
    title: "Zero Fees, 100% Yours",
    description: "Keep every single diamond you earn. No cuts, no hidden fees, ever.",
  },
  {
    icon: Shield,
    title: "Close TikTok Relationship",
    description: "We maintain a close working relationship with TikTok and deep platform expertise.",
  },
  {
    icon: Users,
    title: "Elite Community",
    description: "Network with rapid-growth influencers and celebrity-level creators dominating TikTok Live.",
  },
  {
    icon: Zap,
    title: "True Freedom",
    description: "No contracts, no lock-ins. Stay because you want to, not because you have to.",
  },
  {
    icon: HeadphonesIcon,
    title: "24/7 VIP Support",
    description: "Your success is our obsession. We're always available when you need us.",
  },
  {
    icon: TrendingUp,
    title: "Accelerated Growth",
    description: "Our proven frameworks help creators reach 1M+ diamonds per month.",
  },
];

const Benefits = () => {
  return (
    <section className="py-24 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            What You Get with <span className="text-primary">VCM</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Everything you need to dominate TikTok Live and maximize your earnings
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="p-8 rounded-2xl bg-background border border-border hover:border-primary/50 transition-all hover:shadow-glow group"
              >
                <div className="mb-4 inline-flex p-3 rounded-xl bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                  <Icon className="text-primary" size={28} />
                </div>
                <h3 className="text-xl font-bold mb-3">{benefit.title}</h3>
                <p className="text-muted-foreground">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
